import { BASE_INPUT_SIZE } from '../VBaseInput/variable';
import { joinCn } from '../util';
import createTwStyle from '../util/createTwStyle';
import type { VInputProps } from './type';

const twStyle = createTwStyle<VInputProps<any>>();

export default twStyle({
  input: ({ size, type }) => [
    joinCn(
      'w-full font-normal',
      'text-black placeholder:text-gray-400 aria-[placeholder]:text-gray-400',
      {
        'text-headline-md': size === BASE_INPUT_SIZE.XL,
        'text-body-xl': size === BASE_INPUT_SIZE.LG,
        'text-body-lg': size === BASE_INPUT_SIZE.MD,
        'text-body-md': size === BASE_INPUT_SIZE.SM,
      },
      {
        'text-right': type === 'number',
      },

      '[&::-webkit-search-cancel-button]:appearance-none',
      '[&::-webkit-search-cancel-button]:hidden',
      '[&::-webkit-search-decoration]:appearance-none',
      '[&::-webkit-search-decoration]:hidden',

      '[&::-webkit-inner-spin-button]:appearance-none',
      '[&::-webkit-inner-spin-button]:m-0',
      '[&::-webkit-outer-spin-button]:appearance-none',
      '[&::-webkit-outer-spin-button]:m-0',
      '[&[type="number"]]:[-moz-appearance:textfield]',
    ),
  ],

  inputIcon: ({ size }) => [
    joinCn({
      'size-6': size === BASE_INPUT_SIZE.XL,
      'size-4': size !== BASE_INPUT_SIZE.XL,
    }),
  ],

  inputRightSide: ({ size }) => [
    joinCn('inline-flex select-none empty:hidden', 'text-primary-500', {
      'text-headline-md': size === BASE_INPUT_SIZE.XL,
      'text-body-xl': size === BASE_INPUT_SIZE.LG,
      'text-body-lg': size === BASE_INPUT_SIZE.MD,
      'text-body-md': size === BASE_INPUT_SIZE.SM,
    }),
  ],
});
